// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { FormFieldStyle } from "@sc/MobiusOverrides/FormField";
import { color, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.container = {
    gap: 12,
    offsetCss: css`
        align-items: flex-start;
        &&& label + ${FormInputWrapper} {
            margin-top: 4px;
        }
    `,
};

productSelectorStyles.qtyGridItem = {
    css: css`
        &&& {
            flex-basis: unset;
            max-width: unset;
        }
        ${FormFieldStyle} {
            width: 50px;
            input {
                text-align: center;
            }
        }
    `,
};

productSelectorStyles.clearIcon = {
    size: 18,
    css: css`
        position: absolute;
        right: 35px;
        top: 33px;
        cursor: pointer;
        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};

productSelectorStyles.unitOfMeasureGridItem = {
    width: [3, 3, 2, 2, 2],
    css: css`
        &:empty {
            display: none;
        }
    `,
};

productSelectorStyles.searchGridItem = {
    css: css`
        flex-basis: unset;
        max-width: 307px;
        position: relative;
    `,
};

productSelectorStyles.buttonGridItem = {
    width: [6, 4, 4, 4, 4],
    css: css`
        &&& {
            margin-top: 22px;
        }
    `,
};

productSelectorStyles.selectButton = {
    typographyProps: {
        size: 12,
        lineHeight: "17px",
    },
    css: css`
        min-width: 117px;
    `,
};

productSelectorStyles.imageWrapper = {
    ...mergeWithCss(productSelectorStyles.imageWrapper, {
        css: css`
            justify-content: center;
            align-items: center;
        `,
    }),
};

productSelectorStyles.productImage = {
    css: css`
        img {
            max-width: 100%;
            max-height: 100%;
            height: auto;
            object-fit: contain;
        }
    `,
};
